<template>
<div class="chapter">
<div class="inner_page">
<h1>Buffalo Bill’s Bold Play</h1>
<h3 class="sigil_not_in_toc">OR,</h3>
<h2 class="sigil_not_in_toc"> The Tiger of the Hills</h2>
<h3 class="sigil_not_in_toc">Prentiss Ingraham</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?2a361b2e